import { CapacitorHttp, HttpOptions, HttpResponse } from "@capacitor/core";
import { LoginFormData } from "../../models/userModel";
import baseHttpOptions from "../../util/http-common";
import { remove, set } from "../../util/storage";

const login = async (reqData: LoginFormData) => {
    /* return http
        .post("/login", data)
        .then((res) => {
            const { token } = res.data;
            return (token)
        })
        .then((token) => {
            set("token", token);
            set("isAuthenticated", "true");
            return (token)
        })
        .catch((err) => console.log(err)) */

    const options: HttpOptions = baseHttpOptions("login");
    options.params = {
        "email": reqData.email,
        "password": reqData.password
    }
    const response: HttpResponse = await CapacitorHttp.post(options);
    const { token } = response.data;
    console.log(response)
    set("token", token);
    set("isAuthenticated", "true");
    return (token)

}

const logout = () => {
    Promise.all([
        remove("token"),
        remove("isAuthenticated")
    ]);
}

const AuthService = {
    login,
    logout
}


export default AuthService;